export interface FileState {
  templates: FileUploadTemplate[];
  users: FileUserResult[];
  results: {
    data: FileUploadResult[];
    total: number;
  };
}

export interface FileUploadTemplate {
  id: number;
  name: string;
}

export interface FileUserResult {
  id: string;
  name: string;
}

export enum FileUploadStatus {
  Waiting = 0, // 処理待ち
  Processing = 1, // 処理中
  Success = 2, // 正常登録
  SystemError = 7, // システムエラー
  DataError = 8, // データエラー
  UploadError = 9, // アップロードエラー
}

export interface FileUploadResult {
  id: string;
  fileName: string;
  fileSize: number;
  userName: string;
  menuName: string;
  templateName: string;
  uploadDate: string;
  result: FileUploadStatus;
  disabled: boolean;
  selected?: boolean;
}
